import type { DomParser } from '../types';

const deepEqual = require('deep-equal');

export const fixDoubleSpacesInHtml = (html: string): string =>
	html && html.replace
		? html.replace(/<\s*p[^>]*>([^<]*)<\s*\/\s*p\s*>/g, (str: string) => str.replace(/  /g, ' &nbsp;'))
		: html;

export const deepEquals = (a: unknown, b: unknown): boolean => deepEqual(a, b);

export const removeRedundantBoldTextAndSpacing = (html: string, parser: DomParser): string => {
	const $ = parser;
	const dummyDiv = $('<div>').html(html);

	const text: string = dummyDiv.text();
	const firstWord = text.trim().split(' ')[0].trim();

	const boldNode = dummyDiv.find('b, strong').first();
	if (firstWord.indexOf(boldNode.text().replace(':', '').trim()) > -1) {
		boldNode.remove();
	}

	if (dummyDiv.text().trim()[0] === ':') {
		dummyDiv.html(dummyDiv.html().replace(':', ''));
	}

	dummyDiv.children().each((_i: number, e: unknown) => {
		const elem = $(e);
		if (elem.text().trim().length === 0) {
			elem.remove();
		}
	});

	dummyDiv.html(removeExtraSpaces(dummyDiv.html(), $));

	return dummyDiv.html().trim();
};

export const removeExtraSpaces = (html: string, parser: DomParser): string => {
	const $ = parser;
	const dummyDiv = $('<div>').html(html);

	dummyDiv.find('p').each(function (this: { html: () => string }) {
		const $this = $(this);
		if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
			$this.remove();
		} else {
			$this.html($this.html().trim());
		}
	});

	return dummyDiv.html().trim();
};

export const fixNonSelfClosingIframes = (html: string): string =>
	html.replace(/<iframe([\s\S][^>]*)\/>/gm, '<iframe$1></iframe>');

const TRIX_ATTACHMENT_SELECTOR = '[data-trix-attachment]';
const TRIX_IMAGE_CONTENT_TYPE = 'image';
const TRIX_FIGURE_ELEMENT_SELECTOR = 'figure.attachment.attachment-preview';

export const convertTrixImagesToSimpleImgTags = (html: string, parser: DomParser): string => {
	const $: DomParser = parser;
	const $node = $('<div></div>').html(html);

	$node.find(TRIX_ATTACHMENT_SELECTOR).each((_: number, el: unknown) => {
		const trixImage = $(el);
		if (trixImage.data().trixContentType === TRIX_IMAGE_CONTENT_TYPE) {
			const url = trixImage.data().trixAttachment.url;
			const img = `<img src=${url}>`;

			const maybeLinkParent = trixImage.closest('a');
			if (maybeLinkParent.length) {
				maybeLinkParent.html(img);
			} else {
				const figureParent = trixImage.closest(TRIX_FIGURE_ELEMENT_SELECTOR);
				figureParent.next().remove();
				figureParent.prev().remove();
				figureParent.replaceWith(img);
			}
		}
	});

	return $node.html();
};
